import { InputFormControl, MeetingRecordCheckboxesFormControl, TextareaFormControl } from 'BrokerTsLib/src/components'
import { Insurer } from 'BrokerTsLib/src/enums'
import { useFormContext } from 'BrokerTsLib/src/rhf'

import { FormBody } from '@/containers/forms/FormBody'
import { FormRow } from '@/containers/forms/FormRow'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { usePartner } from '@/context/PartnerContext'
import { useSelectedQuote } from '@/context/SelectedQuoteContext'

import { allianzConsequencesTexts, allianzReasonsTexts } from '@/utils/meetingRecordUtils'
import type { Step4FormValues } from '../Step4'

const CommonMeetingRecordForm = () => {
  const { currentPartner } = usePartner()
  const { control, getValues } = useFormContext<Step4FormValues>()
  const { offer } = useSelectedQuote()
  const { isDisabled } = useInsuranceParams()

  // obcas pri prvnim renderu po sjednani zustaval jeste tento formular a padalo to. Neumim zatim resit jinak (callback na useEffect ve Step4.tsx nezabral)
  if (!control) return null

  const showPlaceOfContract =
    [Insurer.GeneraliCeskaPojistovna, Insurer.CPP].includes(
      offer?.insurerId ?? 0,
    ) ||
    ((offer?.insurerId ?? 0) == Insurer.Uniqa &&
      currentPartner!.partner != 'Jap') //JAP-1502



  const showAllianzZZJ =
    (offer?.insurerId ?? 0) == Insurer.Allianz &&
    getValues('meetingRecord.useInsurerZZJ')

  return (
    <FormBody>
      {!showAllianzZZJ && (<TextareaFormControl
        label="Případné nesrovnalosti mezi požadavky Zákazníka a sjednávaným
          pojištěním nebo jeho podstatnou změnou"
        name='meetingRecord.irregularities'
        control={control}
        isDisabled={isDisabled}
        helperText="Uveďte nesrovnalosti mezi nabízeným pojištěním a požadavky klienta.
          Tyto údaje se propíšou do Záznamu z jednání, které klient podepisuje."
        variant="flushed"
      />)}

      {!showAllianzZZJ && (
        <TextareaFormControl
          label="Důvody, na kterých je doporučení založeno"
          name='meetingRecord.reasons'
          control={control}
          isDisabled={isDisabled}
          helperText="Po vyhodnocení výše uvedených požadavků a potřeb Zákazníka v
      požadovaných oblastech pojištění a při zohlednění jeho znalostí,
      zkušeností a finanční situace doporučuje Zprostředkovatel následující
      produkty. Toto doporučení je založeno pouze na vyhodnocení produktů,
      které je Zprostředkovatel a jeho zástupce oprávněn zprostředkovávat."
          variant="flushed"
        />
      )}

      {showAllianzZZJ && <AllianzZZJ />}

      {showPlaceOfContract && (
        <FormRow>
          <InputFormControl
            label="Místo sjednání"
            name="meetingRecord.placeOfContract"
            control={control}
            isDisabled={isDisabled}
          />
        </FormRow>
      )}
    </FormBody>
  )
}

export default CommonMeetingRecordForm

const AllianzZZJ = () => {
  const { control } = useFormContext<Step4FormValues>()
  const { isDisabled } = useInsuranceParams()
  
  return <>
    <TextareaFormControl
      label="Doplňující údaje klienta"
      name='meetingRecord.additionalClientRequirements'
      control={control}
      isDisabled={isDisabled}
      variant="flushed"
    />
    <TextareaFormControl
      label="Doplňující údaje zprostředkovatele"
      name='meetingRecord.reasons'
      control={control}
      isDisabled={isDisabled}
      variant="flushed"
    />
    <MeetingRecordCheckboxesFormControl
      label="Důvody zakládající doporučené pojištění"
      name='meetingRecord.reasonsForRecommendation'
      isDisabled={isDisabled}
      checkboxTexts={allianzReasonsTexts}
      textareaVariant="flushed"
      isRequired
    />
    <MeetingRecordCheckboxesFormControl
      label="Dopady pojištění na klienta a rizika s ním spojená"
      name='meetingRecord.effectsAndRisksText'
      isDisabled={isDisabled}
      checkboxTexts={allianzConsequencesTexts}
      textareaVariant="flushed"
      isRequired
    />
  </>
}